import React from 'react';
import { motion } from 'framer-motion';
import { Award, Heart, Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './FounderStory.css';

const FounderStory = () => {
  const { t } = useTranslation();
  
  return (
    <section className="founder-story-section" id="about">
      <div className="founder-story-container">
        <motion.div
          className="founder-content-wrapper"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="founder-image-section"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="founder-image-wrapper">
              <div className="founder-image-frame">
                <img
                  src="https://customer-assets.emergentagent.com/job_luxury-builders-3/artifacts/pdlsbgpf_orhan%20gedik.png"
                  alt="Orhan Gedik - Kurucu"
                  className="founder-image"
                />
                <div className="founder-image-overlay"></div>
              </div>
              
              <div className="founder-badge">
                <Award size={18} />
                <div className="founder-badge-text">
                  <span className="badge-years">30+</span>
                  <span className="badge-label">{t('founder.badge')}</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="founder-text-section"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="founder-header">
              <div className="founder-subtitle">
                <Shield size={14} />
                <span>{t('founder.subtitle')}</span>
              </div>
              <h2 className="founder-title">{t('founder.title')}</h2>
            </div>

            <div className="founder-story-text">
              <p dangerouslySetInnerHTML={{ __html: t('founder.paragraph1') }} />
              
              <p dangerouslySetInnerHTML={{ __html: t('founder.paragraph2') }} />

              <div className="founder-quote">
                <Heart size={18} className="quote-icon" />
                <p className="quote-text">
                  {t('founder.quote')}
                </p>
              </div>
            </div>

            <div className="founder-values">
              <div className="value-item">
                <div className="value-icon">
                  <Shield size={16} />
                </div>
                <div className="value-text">
                  <h4>{t('founder.trust')}</h4>
                  <p>{t('founder.trustDesc')}</p>
                </div>
              </div>
              
              <div className="value-item">
                <div className="value-icon">
                  <Award size={16} />
                </div>
                <div className="value-text">
                  <h4>{t('founder.quality')}</h4>
                  <p>{t('founder.qualityDesc')}</p>
                </div>
              </div>
              
              <div className="value-item">
                <div className="value-icon">
                  <Heart size={16} />
                </div>
                <div className="value-text">
                  <h4>{t('founder.customerFocus')}</h4>
                  <p>{t('founder.customerFocusDesc')}</p>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default FounderStory;
